export enum GACustomEventName {
  APP_OPENED = 'appOpened',
}
